(() => {
  const COLLECTION_HANDLE = 'meet-your-new-hair-ritual';
  const MODULE_ID = 'hue-single-grid-module';
  const HUE_PRODUCT_ID = 'hair-ritual-collection';

  if (!window.location.pathname.includes(`/collections/${COLLECTION_HANDLE}`)) return;

  function loadHueScriptOnce() {
    if (window.__hueIntegrationLoaded) return;
    if (document.querySelector('script[src="https://app.poweredbyhue.app/js/integration.js"]')) {
      window.__hueIntegrationLoaded = true;
      return;
    }

    window.__hueIntegrationLoaded = true;

    const script = document.createElement('script');
    script.src = 'https://app.poweredbyhue.app/js/integration.js';
    script.defer = true;
    document.head.appendChild(script);
  }

  function insertHueModule() {
    const grid = document.querySelector('#ResultsList ul.product-grid');

    if (!grid) return;
    if (document.getElementById(MODULE_ID)) return;

    const cards = Array.from(grid.querySelectorAll(':scope > li.product-grid__item'));

    if (cards.length < 3) return;

    const module = document.createElement('li');
    module.id = MODULE_ID;
    module.className = 'product-grid__item hue-single-grid-module-item';
    module.setAttribute('data-page', '1');

    module.innerHTML = `
      <div
        id="hue-single-review-module"
        class="hue-single-review-module"
        data-product-id="${HUE_PRODUCT_ID}"
      ></div>
    `;

    grid.insertBefore(module, cards[2]);

    loadHueScriptOnce();
  }

  function init() {
    insertHueModule();

    const resultsList = document.querySelector('#ResultsList');
    if (!resultsList) return;

    const observer = new MutationObserver(() => {
      insertHueModule();
    });

    observer.observe(resultsList, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();